import { render } from "./PremiumHomeDelivery.vue?vue&type=template&id=18c97bb0"
import script from "./PremiumHomeDelivery.vue?vue&type=script&lang=js"
export * from "./PremiumHomeDelivery.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__